import * as React from "react";

const GoDeeperArrow = (props: {forwardAction: (e) => void, running: boolean}) => {
    if (props.running) {
        return <span className={'navigateArrowRight navigateArrowRight--visible'}><i className={'far fa-spinner fa-spin'}></i></span>;
    }
    return <span onClick={props.forwardAction} className={'navigateArrowRight'} title={I18N('js_go_deeper')}>
        <i className={'fal fa-chevron-circle-right'}></i>
    </span>
}

const GoBackArrow = (props: {backAction: (e) => void, running: boolean}) => {
    if (props.running) {
        return <span className={'navigateArrowLeft'}><i className={'far fa-spinner fa-spin'}></i></span>;
    }
    return <span onClick={props.backAction} className={'navigateArrowLeft'} title={I18N('js_go_back')}>
        <i className={'fal fa-chevron-left'}></i>
    </span>
}

export {GoDeeperArrow, GoBackArrow};
